module.exports = "dist/images/components-design-separator-control-rounded-1.d2b77d9.png";